import React, { useEffect, useState } from "react";
import {
    Form,
    Select,
    Row,
    Col,
    Button,
    Input,
    Table,
    message,
    Tabs,
    Modal,
    DatePicker,
    TimePicker,
    Spin
} from "antd";
import ServiceHistory from "./ServiceHistory";
import { formatValue } from "../../../../../utils";
import "./index.less";
import { platformApi } from "../../../../../api";
const { TabPane } = Tabs;
const { Item } = Form;
const { Option } = Select;
const { TextArea } = Input;
import WrappedUploadDocuments from "./UploadDocuments";
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { add, indexOf } from "lodash";
import empty from "../../../../../assets/empty.png";
import Documents from "./Documents";
import InsuranceForm from "./InsuranceForm";
import moment from "moment";
import { buildServiceOptions, determineEligibleService, getNextScheduledService } from "./serviceEligibility";
const Overview = ({
    form,
    validityRef,
    data,
    clearRef,
    open,
    editable,
    setDetails,
    Details,
    recvData,
    selectedNumber,
    selectedPhone,
    setLoading,
    AccidentalDocuments,
    setAccidentalDocuments,
    ...props
}) => {
    const { getFieldDecorator, getFieldValue } = form;
    const [vehicleId, setVehicleImage] = useState();
    const [complaintList, setComplaintList] = useState([{ complaint: "" }]);
    const [count, setCount] = useState(1);
    const [error, setError] = useState({});
    const [checkAll, setCheckAll] = useState(false);
    const [checkkms, setCheckkms] = useState(true);
    const [fuelLevel, setFuelLevel] = useState();
    const [couponNumber, setCouponNumber] = useState();
    //CHECK STATES
    const [PcheckedList, setPCheckedList] = useState([]);
    const [Pindeterminate, setPIndeterminate] = useState(true);
    const [PcheckAll, setPCheckAll] = useState(false);
    //IMAGES
    const [fileList, setFileList] = useState([]);
    const [RHSfileList, setRHSFileList] = useState([]);
    const [RearfileList, setRearFileList] = useState([]);
    const [LHSfileList, setLHSFileList] = useState([]);
    const [TopfileList, setTopFileList] = useState([]);
    const [additionalFileList, setAdditionalFileList] = useState([]);
    //FORM DATA
    const [FrontForm, setFrontForm] = useState("");
    const [RHSForm, setRHSForm] = useState("");
    const [LHSForm, setLHSForm] = useState("");
    const [RearForm, setRearForm] = useState("");
    const [TopForm, setTopForm] = useState("");
    //IMAGES
    const [frontImg, setFront] = useState();
    const [RHSImg, setRhs] = useState();
    const [LHSImg, setLhs] = useState();
    const [RearImg, setRear] = useState();
    const [TopImg, setTop] = useState();
    const [AdditionalImages, setAdditionalImages] = useState([]);
    const [service, setService] = useState(recvData ? recvData.serviceType : "");
    const [serviceOptions, setServiceOptions] = useState([]);
    const [eligibleService, setEligibleService] = useState(null);
    const [selectedServiceNo, setSelectedServiceNo] = useState(recvData ? recvData.serviceNo : "");
    const [kmsInput, setKmsInput] = useState("");
    const [lastServiceNumber, setLastServiceNumber] = useState(0);

        const [previewVisible, setPreviewVisible] = useState(false);

        const [batteryNo, setBatteryNo] = useState("");
        const [batteryDoc, setBatteryDoc] = useState(null);
        const [batteryFileList, setBatteryFileList] = useState([]);

        const [estimationData, setEstimationData] = useState([]);
        const [estimationLoading, setEstimationLoading] = useState(false);

        const estimationColumns = [
          {
            title: "S.No",
            dataIndex: "sno",
            key: "sno",
            width: 80,
            align: "center"
          },
          {
            title: "Parts Details",
            dataIndex: "details",
            key: "details"
          },
          {
            title: "Quantity",
            dataIndex: "qty",
            key: "qty",
            width: 110,
            align: "center"
          },
          {
            title: "Unit rate",
            dataIndex: "unitRate",
            key: "unitRate",
            width: 140,
            align: "right",
            render: (rate) => `₹ ${(parseFloat(rate) || 0).toFixed(2)}`
          },
          {
            title: "Amount",
            dataIndex: "amount",
            key: "amount",
            width: 150,
            align: "right",
            render: (amount) => `₹ ${(parseFloat(amount) || 0).toFixed(2)}`
          }
        ];

        useEffect(() => {
          const currentServiceNo = form.getFieldValue("serviceNo") || recvData?.serviceNo;
          const currentKms = kmsInput || form.getFieldValue("kms") || recvData?.kms;
          const vehicleObj = data?.selectVehicle || recvData?.vehicle;
          const vehicleModelId = vehicleObj?.vehicle?.id || vehicleObj?.vehicleMaster?.id || vehicleObj?.vehicleModel || (typeof vehicleObj?.vehicle === 'string' ? vehicleObj.vehicle : '');

          if (vehicleModelId && (currentServiceNo || currentKms)) {
            setEstimationLoading(true);
            platformApi
              .post("/api/pmc/getCodes", {
                model: vehicleModelId,
                serviceNo: currentServiceNo,
                kms: currentKms
              })
              .then((res) => {
                const pmcList = res.data?.response?.data || res.data?.data || res.data?.response || [];
                if (Array.isArray(pmcList) && pmcList.length > 0) {
                  const pmcItem = pmcList[0];
                  const list = [];
                  let index = 1;

                  if (pmcItem.partsConsumable && Array.isArray(pmcItem.partsConsumable)) {
                    pmcItem.partsConsumable.forEach((item) => {
                      if (item.partNumber) {
                        const qty = parseFloat(item.quantity) || 1;
                        const unitRate = parseFloat(item.partNumber.mrp) || 0;
                        const amount = qty * unitRate;
                        list.push({
                          key: `part-${item.id || index}`,
                          sno: index++,
                          details: `${item.partNumber.partName || ''}${item.partNumber.partNumber ? ` (${item.partNumber.partNumber})` : ''}`,
                          qty: qty,
                          unitRate: unitRate,
                          amount: amount
                        });
                      }
                    });
                  }

                  if (pmcItem.jobCodes && Array.isArray(pmcItem.jobCodes)) {
                    pmcItem.jobCodes.forEach((item) => {
                      if (item.jobCode) {
                        const qty = parseFloat(item.quantity) || 1;
                        const vehiclePriceEntry = item.jobCode.vehicleModel && Array.isArray(item.jobCode.vehicleModel)
                          ? item.jobCode.vehicleModel.find(vm => vm.vehicle && (vm.vehicle.id === vehicleModelId || vm.vehicle.modelCode === vehicleModelId))
                          : null;
                        const unitRate = vehiclePriceEntry
                          ? (parseFloat(vehiclePriceEntry.price) || 0)
                          : (parseFloat(item.jobCode.vehicleModel?.[0]?.price) || 0);
                        const baseAmount = qty * unitRate;

                        // Both Labour and Consumable Job Codes: GST is exclusive (added on top of base rate).
                        const isConsumable = Boolean(item.jobCode.consumable);
                        let finalAmount = baseAmount;
                        let gstRate = 0;

                        if (item.jobCode.sac) {
                          const sac = item.jobCode.sac;
                          const cgst = parseFloat(sac.cgst) || 0;
                          const sgst = parseFloat(sac.sgst) || 0;
                          const igst = parseFloat(sac.igst) || 0;
                          gstRate = (cgst + sgst) || igst || 0;
                          const gstAmount = (baseAmount * gstRate) / 100;
                          finalAmount = baseAmount + gstAmount;
                        }

                        list.push({
                          key: `job-${item.id || index}`,
                          sno: index++,
                          details: `${item.jobCode.description || ''}${item.jobCode.code ? ` (${item.jobCode.code})` : ''}`,
                          qty: qty,
                          unitRate: unitRate,
                          amount: finalAmount,
                          gstRate: gstRate,
                          isLabour: !isConsumable,
                          isConsumable: isConsumable
                        });
                      }
                    });
                  }

                  setEstimationData(list);
                } else {
                  setEstimationData([]);
                }
              })
              .catch((err) => {
                console.error("Error fetching PMC estimation:", err);
                setEstimationData([]);
              })
              .finally(() => {
                setEstimationLoading(false);
              });
          } else {
            setEstimationData([]);
          }
        }, [form.getFieldValue("serviceNo"), kmsInput, data?.selectVehicle, recvData?.vehicle, recvData?.serviceNo, recvData?.kms]);

        const vid = props.vehicleId;


        useEffect(() => {
          clearRef.current = () => {
            form.resetFields();
          };
          validityRef.current = () => {
            return validatePage();
          };
          return () => {
            validityRef.current = null;
            clearRef.current = null;
          };
        });
        const getDisabledHours = () => {
          const selectedDate = form.getFieldValue("expectedDeliveryDate");
          if (selectedDate && moment(selectedDate).isSame(moment(), 'day')) {
            const currentHour = moment().hour();
            const disabled = [];
            for (let i = 0; i < currentHour; i++) {
              disabled.push(i);
            }
            return disabled;
          }
          return [];
        };

        const getDisabledMinutes = (selectedHour) => {
          const selectedDate = form.getFieldValue("expectedDeliveryDate");
          if (selectedDate && moment(selectedDate).isSame(moment(), 'day')) {
            const currentHour = moment().hour();
            if (selectedHour === currentHour) {
              const currentMinute = moment().minute();
              const disabled = [];
              for (let i = 0; i < currentMinute; i++) {
                disabled.push(i);
              }
              return disabled;
            }
          }
          return [];
        };

        const validatePage = () => {
          let isValid;
          form.validateFields((validationError) => {
            isValid = validationError === null;
          });
          let temp = complaintList.filter((i) => {
            return i.complaint.length > 0;
          });
          if (
            complaintList.length === 0 ||
            (complaintList.length > 0 && complaintList[0].complaint.length == 0)
          ) {
            message.error("Please Add the Complaint!!!");
            isValid = false;
          }
          const rawServiceType = form.getFieldValue("serviceType");
          const selectedOpt = serviceOptions.find((o) => o.value === rawServiceType || o.label === rawServiceType);

          if (selectedOpt && selectedOpt.isScheduled && eligibleService) {
            const candidates = eligibleService.eligibleCandidates || (eligibleService.eligible ? [eligibleService.eligible] : (eligibleService.value ? [eligibleService] : []));
            const isMatched = candidates.some((c) => {
              if (c.value === selectedOpt.value) return true;
              if (c.serviceNo === selectedOpt.serviceNo && c.serviceType === selectedOpt.serviceType) return true;
              if (c.serviceNo && selectedOpt.serviceNo && parseInt(selectedOpt.serviceNo, 10) >= parseInt(c.serviceNo, 10)) return true;
              return false;
            });
            if (!isMatched) {
              const eligibleLabel = eligibleService.eligibleLabel || eligibleService.eligible?.label || eligibleService.label || "";
              message.error(
                `Error: As per KMS entered and number of Days, you are eligible for (${eligibleLabel}).`,
                5
              );
              const primary = eligibleService.eligible || candidates[0] || eligibleService;
              if (primary && primary.value) {
                form.setFieldsValue({
                  serviceType: primary.value,
                });
                setSelectedServiceNo(primary.serviceNo ? String(primary.serviceNo) : "");
                setService(primary.serviceType);
              }
              isValid = false;
            }
          }

          const resolvedServiceType = selectedOpt ? selectedOpt.serviceType : rawServiceType;
          const resolvedServiceNo = selectedOpt && selectedOpt.serviceNo ? String(selectedOpt.serviceNo) : (selectedServiceNo || "");

          if (resolvedServiceType === "Accidental") {
            if (!FrontForm || !RHSForm || !LHSForm || !RearForm || !TopForm) {
              message.error("Front, RHS, LHS, Rear and Top view images are mandatory for Accidental service!");
              isValid = false;
            }
          }
          if (isValid) {
            setComplaintList(temp);
            data.kms = parseInt(getFieldValue("kms"));
            const selectedDate = getFieldValue("expectedDeliveryDate");
            const selectedTime = getFieldValue("expectedDeliveryTime");
            if (selectedDate && selectedTime) {
              const combined = moment(selectedDate)
                .hour(selectedTime.hour())
                .minute(selectedTime.minute())
                .second(0)
                .millisecond(0);
              data.expectedDeliveryDate = combined.toISOString();
            } else if (selectedDate) {
              data.expectedDeliveryDate = selectedDate.toISOString();
            } else {
              data.expectedDeliveryDate = null;
            }
            data.serviceType = resolvedServiceType;
            data.serviceNo = resolvedServiceNo;
            data.couponNo = getFieldValue("couponNo");
            data.complaintList = complaintList;
            data.vehicle = data.selectVehicle;
            data.fuelLevel = parseInt(fuelLevel);
            data.PcheckedList = PcheckedList;
            data.front = FrontForm;
            data.rhs = RHSForm;
            data.lhs = LHSForm;
            data.top = TopForm;
            data.rear = RearForm;
            data.vehicleId = vehicleId ? vehicleId : "";

      if (!data.vehicleImage) {
        data.vehicleImage = {};
      }
      data.vehicleImage.additionalImages = AdditionalImages || [];
      data.accidentalDocuments = AccidentalDocuments || [];
      data.batteryNo = getFieldValue("batteryNo") || batteryNo;
      data.batteryDoc = batteryDoc;
    }
    return isValid;
  };
  useEffect(() => {
    if (
      complaintList.length > 0 &&
      complaintList[complaintList.length - 1].complaint.length > 0
    ) {
      addComplaint();
    }
  }, [
    complaintList.length > 0 &&
      complaintList[complaintList.length - 1].complaint,
  ]);

  useEffect(() => {
    selectedNumber &&
      selectedPhone &&
      data.selectVehicle.customer.map((item) => {
        if (item.customer.id === selectedNumber) {
          let cusdata = {
            phone: selectedPhone,
          };
          item.customer.contacts.push(cusdata);
        }
        let contacts = item.customer.contacts;
        data.customerPhone = selectedPhone;
        if (item.customer.contacts.length === 0) {
          item.customer.contacts = contacts;
        }
      });

    form.setFieldsValue({
      couponNo:
        data.selectVehicle && data.selectVehicle.serviceCouponNumber
          ? data.selectVehicle.serviceCouponNumber
          : null,
    });
    setCouponNumber(data.selectVehicle.serviceCouponNumber);
    if (data.selectVehicle.customer.length > 0) {
      data.customer = selectedNumber
        ? data.selectVehicle.customer.customer
          ? data.selectVehicle.customer.customer.find((item) => {
              return item.customer.id === selectedNumber;
            })
          : data.selectVehicle.customer.find((item) => {
              return item.customer.id === selectedNumber;
            })
        : data.selectVehicle.customer[0].customer;
    }
  }, [selectedNumber, selectedPhone]);

  useEffect(() => {
    if (!data?.selectVehicle?.jobOrder) return;
    let serviceNo = 0;
    for (const job of data.selectVehicle.jobOrder) {
      if (job.serviceNo && parseInt(job.serviceNo) > serviceNo)
        serviceNo = parseInt(job.serviceNo);
    }
    setLastServiceNumber(serviceNo);
  }, [data]);

  useEffect(() => {
    const vehicleObj = data?.selectVehicle || recvData?.vehicle;
    const rawServices = vehicleObj?.services || vehicleObj?.vehicle?.services || [];
    const jobOrders = vehicleObj?.jobOrder || [];
    const currentJobCardId = recvData?.id || recvData?._id || null;
    const options = buildServiceOptions(rawServices, jobOrders, currentJobCardId);
    setServiceOptions(options);

    const initialKms = kmsInput || (recvData && recvData.kms);
    if (initialKms) {
      const currentKm = parseInt(initialKms, 10);
      if (!isNaN(currentKm) && currentKm > 0) {
        const jobCardDate = recvData?.createdAt || moment();
        const result = determineEligibleService({
          services: rawServices,
          jobOrders,
          kms: currentKm,
          jobCardDate,
          currentJobCardId,
        });
        setEligibleService(result);
      }
    } else if (!recvData || Object.keys(recvData).length === 0) {
      // Initially before user enters KMS, autofill next service based on previous service history
      const nextService = getNextScheduledService(rawServices, jobOrders, currentJobCardId);
      if (nextService) {
        setEligibleService({
          eligible: nextService,
          eligibleCandidates: [nextService],
          eligibleLabel: nextService.label,
        });
        form.setFieldsValue({
          serviceType: nextService.value,
        });
        setSelectedServiceNo(nextService.serviceNo ? String(nextService.serviceNo) : "");
        setService(nextService.serviceType);
      }
    }
  }, [data?.selectVehicle, recvData?.vehicle, recvData]);

  const evaluateKmsAndAutoFill = (val) => {
    const currentKm = parseInt(val, 10);
    if (isNaN(currentKm) || currentKm <= 0) return;

    const vehicleObj = data?.selectVehicle || recvData?.vehicle;
    const rawServices = vehicleObj?.services || vehicleObj?.vehicle?.services || [];
    const jobOrders = vehicleObj?.jobOrder || [];
    const jobCardDate = recvData?.createdAt || moment();
    const currentJobCardId = recvData?.id || recvData?._id || null;

    const result = determineEligibleService({
      services: rawServices,
      jobOrders,
      kms: currentKm,
      jobCardDate,
      currentJobCardId,
    });

    setEligibleService(result);

    if (result.eligible) {
      form.setFieldsValue({
        serviceType: result.eligible.value,
      });
      setSelectedServiceNo(result.eligible.serviceNo ? String(result.eligible.serviceNo) : "");
      setService(result.eligible.serviceType);
      setCheckAll(result.eligible.serviceType === "Free");
    }
  };

  const columns = [
    {
      title: "Complaint No",
      render: (data) => <h3>{complaintList.indexOf(data) + 1}</h3>,
    },
    {
      title: "Complaint",
      render: (data) => (
        <div>
          <TextArea
            disabled={!editable}
            onChange={(e) => saveComplaint(complaintList.indexOf(data), e)}
            value={data.complaint}
            rows={3}
          />
        </div>
      ),
    },
    {
      title: "Action",
      render: (data) => (
        <Button disabled={!editable} onClick={() => deleteComplaintData(data)}>
          <MinusCircleOutlined />
        </Button>
      ),
    },
  ];
  const saveComplaint = (index, e) => {
    let complaint = complaintList;
    complaint[index].complaint = e.target.value;
    setComplaintList([...complaint]);
  };
  const addComplaint = () => {
    complaintList.push({ complaint: "" });
    setCount(count + 1);
    setComplaintList([...complaintList]);
  };
  const deleteComplaintData = (complaint) => {
    let complaints = complaintList.filter(
      (data) => complaintList.indexOf(data) != complaintList.indexOf(complaint)
    );
    setComplaintList(complaints);
  };
  const handleServiceType = (val) => {
    const selectedOpt = serviceOptions.find((o) => o.value === val || o.label === val);

    // If selecting a scheduled service, validate against eligibleService
    if (selectedOpt && selectedOpt.isScheduled && eligibleService) {
      const candidates = eligibleService.eligibleCandidates || (eligibleService.eligible ? [eligibleService.eligible] : (eligibleService.value ? [eligibleService] : []));
      const isMatched = candidates.some((c) => {
        if (c.value === selectedOpt.value) return true;
        if (c.serviceNo === selectedOpt.serviceNo && c.serviceType === selectedOpt.serviceType) return true;
        if (c.serviceNo && selectedOpt.serviceNo && parseInt(selectedOpt.serviceNo, 10) >= parseInt(c.serviceNo, 10)) return true;
        return false;
      });

      if (!isMatched) {
        const eligibleLabel = eligibleService.eligibleLabel || eligibleService.eligible?.label || eligibleService.label || "";
        message.error(
          `Error: As per KMS entered and number of Days, you are eligible for (${eligibleLabel}).`,
          5
        );
        const primary = eligibleService.eligible || candidates[0] || eligibleService;
        if (primary && primary.value) {
          // Defer setFieldsValue so AntD rc-form onChange doesn't override with selected value
          setTimeout(() => {
            form.setFieldsValue({
              serviceType: primary.value,
            });
          }, 0);
          setSelectedServiceNo(primary.serviceNo ? String(primary.serviceNo) : "");
          setService(primary.serviceType);
          setCheckAll(primary.serviceType === "Free");
        }
        return;
      }
    }

    if (selectedOpt) {
      setService(selectedOpt.serviceType);
      setSelectedServiceNo(selectedOpt.serviceNo ? String(selectedOpt.serviceNo) : "");

      if (selectedOpt.serviceType === "Free" || selectedOpt.value === "AMC") {
        setCheckAll(true);
      } else {
        setCheckAll(false);
      }
      // Minor / Quick repair does not use coupon number
      if (
        selectedOpt.serviceType === "Minor" ||
        String(selectedOpt.value || "")
          .toLowerCase()
          .includes("minor")
      ) {
        form.setFieldsValue({ couponNo: undefined });
      }
    } else {
      setService(val);
      setSelectedServiceNo("");
      if (val === "Free" || val === "AMC") {
        setCheckAll(true);
      } else {
        setCheckAll(false);
      }
      if (String(val || "").toLowerCase().includes("minor")) {
        form.setFieldsValue({ couponNo: undefined });
      }
    }
  };

  useEffect(() => {
    if (Object.keys(recvData).length > 0) {
      const bNo = recvData.vehicle?.batteryNo || data.selectVehicle?.batteryNo || "";
      setBatteryNo(bNo);
      if (recvData.batteryDoc) {
        setBatteryDoc(recvData.batteryDoc);
      }
      let initialServiceType = recvData.serviceType;
      if (recvData.serviceNo && recvData.serviceType) {
        initialServiceType = `${recvData.serviceNo}-${recvData.serviceType}`;
      }
      setSelectedServiceNo(recvData.serviceNo ? String(recvData.serviceNo) : "");
      form.setFieldsValue({
        kms: recvData.kms,
        serviceType: initialServiceType,
        couponNo: recvData.couponNo,
        batteryNo: bNo,
        expectedDeliveryDate: recvData.expectedDeliveryDate 
          ? moment(recvData.expectedDeliveryDate) 
          : undefined,
        expectedDeliveryTime: recvData.expectedDeliveryDate
          ? moment(recvData.expectedDeliveryDate)
          : undefined,
      });
      setKmsInput(recvData.kms || "");
      let compz = [];
      recvData.complaint &&
        recvData.complaint.map((obj) => {
          let newObjz = {
            complaint: obj.complaint,
            id: obj.id,
          };
          compz.push(newObjz);
        });
      if (compz.length > 0) {
        setComplaintList([...compz]);
      }
      setFuelLevel(recvData.fuelLevel);
      let partsResults = [];
      if (recvData.parts != null && recvData.parts.MirrorRH)
        partsResults.push("MirrorRH");
      if (recvData.parts != null && recvData.parts.MirrorLH)
        partsResults.push("MirrorLH");
      if (recvData.parts != null && recvData.parts.Toolkit)
        partsResults.push("Toolkit");
      if (recvData.parts != null && recvData.parts.FirstAdKit)
        partsResults.push("FirstAdKit");

      setPCheckedList([...partsResults]);
      setFront(
        recvData.vehicleImage && recvData.vehicleImage.frontView
          ? recvData.vehicleImage.frontView
          : ""
      );
      setRear(
        recvData.vehicleImage && recvData.vehicleImage.rearView
          ? recvData.vehicleImage.rearView
          : ''
      );
      setRhs(
        recvData.vehicleImage && recvData.vehicleImage.rhsView
          ? recvData.vehicleImage.rhsView
          : ""
      );
      setLhs(
        recvData.vehicleImage && recvData.vehicleImage.lhsView
          ? recvData.vehicleImage.lhsView
          : ""
      );
      setTop(
        recvData.vehicleImage && recvData.vehicleImage.topView
          ? recvData.vehicleImage.topView
          : ""
      );
      setFrontForm(
        recvData.vehicleImage && recvData.vehicleImage.frontView
          ? recvData.vehicleImage.frontView
          : ""
      );
      setRHSForm(
        recvData.vehicleImage && recvData.vehicleImage.rhsView
          ? recvData.vehicleImage.rhsView
          : ""
      );
      setLHSForm(
        recvData.vehicleImage && recvData.vehicleImage.lhsView
          ? recvData.vehicleImage.lhsView
          : ""
      );
      setRearForm(
        recvData.vehicleImage && recvData.vehicleImage.rearView
          ? recvData.vehicleImage.rearView
          : ""
      );
      setTopForm(
        recvData.vehicleImage && recvData.vehicleImage.topView
          ? recvData.vehicleImage.topView
          : ""
      );
      setAccidentalDocuments(
        recvData.accidentalDocuments ? recvData.accidentalDocuments : ""
      );

      const additionalImages = recvData.vehicleImage?.additionalImages || [];

      const accidentalDocuments = recvData.accidentalDocuments;

      data.vehicleImage.additionalImages = additionalImages;
      setAdditionalImages(additionalImages);

      data.accidentalDocuments = AccidentalDocuments || [];
    }
  }, [recvData, editable]);

      return (
        <>
          <Row>
            <Col span={2}></Col>
            <Col span={20}>
              <Tabs
                defaultActiveKey="1"
                centered
                style={{ backgroundColor: "white" }}
              >
                <TabPane tab="Complaints" key="1">
                  <>
                    <Form style={{ marginTop: "4%", marginBottom: "4%" }}>
                      <Row type="flex" justify="space-around">
                        <Col span={7}>
                          <Form.Item
                            colon={false}
                            validateStatus={error.kms && error.kms.type}
                            help={error.kms && error.kms.message}
                            label="Kms"
                          >
                            {getFieldDecorator("kms", {
                              rules: [
                                {
                                  required: true,
                                  message: "Enter KMS",
                                },
                              ],
                            })(
                              <Input
                                type="number"
                                disabled={!editable}
                                placeholder="KMs"
                                onKeyUp={(e) => {
                                  const val = formatValue(e, "onlyNo");
                                  form.setFieldsValue({
                                    kms: val,
                                  });
                                  setKmsInput(val);
                                  evaluateKmsAndAutoFill(val);
                                }}
                                onChange={(event) => {
                                  const val = event.target.value;
                                  setKmsInput(val);
                                  evaluateKmsAndAutoFill(val);
                                  if (!event.target.checkValidity()) {
                                    setError({
                                      ...error,
                                      kms: {
                                        type: "error",
                                        message: "Enter Valid KMS",
                                      },
                                    });
                                  } else {
                                    delete error.kms;
                                    setError(error);
                                  }
                                }}
                              />
                            )}
                          </Form.Item>
                        </Col>
                        <Col span={7}>
                          <Form.Item colon={false} label="Service Type">
                            {form.getFieldDecorator("serviceType", {
                              rules: [
                                {
                                  required: true,
                                  message: "Select ServiceType!",
                                },
                              ],
                            })(
                              <Select
                                placeholder="Select Service"
                                disabled={!editable}
                                onChange={handleServiceType}
                              >
                                {serviceOptions.map((opt) => (
                                  <Select.Option key={opt.value} value={opt.value}>
                                    {opt.label}
                                  </Select.Option>
                                ))}
                              </Select>
                            )}
                          </Form.Item>
                        </Col>
                        {(() => {
                          const selectedVal =
                            form.getFieldValue("serviceType") || service || "";
                          const selectedOpt = serviceOptions.find(
                            (o) =>
                              o.value === selectedVal ||
                              o.label === selectedVal ||
                              o.serviceType === selectedVal
                          );
                          const isMinor =
                            service === "Minor" ||
                            selectedOpt?.serviceType === "Minor" ||
                            String(selectedVal).toLowerCase().includes("minor");
                          // Keep empty Col so Kms / Service Type stay in the same columns
                          if (isMinor) {
                            return <Col span={7} />;
                          }
                          return (
                        <Col span={7}>
                          <Form.Item
                            colon={false}
                            label="Service Coupon Number"
                            validateStatus={error.couponNo && error.couponNo.type}
                            help={error.couponNo && error.couponNo.message}
                          >
                            {getFieldDecorator("couponNo", {
                              rules: [
                                {
                                  required: false,
                                },
                              ],
                            })(
                              <Input
                                type="number"
                                placeholder="Service Coupon Number."
                                disabled={!editable}
                                onKeyUp={(e) =>
                                  form.setFieldsValue({
                                    couponNo: formatValue(e, "onlyNo"),
                                  })
                                }
                                onChange={(event) => {
                                  if (!event.target.checkValidity()) {
                                    setError({
                                      ...error,
                                      couponNo: {
                                        type: "error",
                                        message: "Enter Valid Service Coupon No",
                                      },
                                    });
                                  } else {
                                    delete error.couponNo;
                                    setError(error);
                                  }
                                }}
                              />
                            )}
                          </Form.Item>
                        </Col>
                          );
                        })()}
                      </Row>
                      <Row type="flex" justify="space-around">
                        <Col span={7}>
                          <Form.Item colon={false} label="Expected Delivery Date">
                            {getFieldDecorator("expectedDeliveryDate", {
                              initialValue: recvData && recvData.expectedDeliveryDate
                                ? moment(recvData.expectedDeliveryDate)
                                : undefined,
                              rules: [
                                {
                                  required: true,
                                  message: "Select Expected Delivery Date!",
                                },
                              ],
                            })(
                              <DatePicker
                                style={{ width: "100%" }}
                                disabled={!editable}
                                disabledDate={(current) => current && current < moment().startOf('day')}
                                format="DD-MM-YYYY"
                                placeholder="Expected Delivery Date"
                                onChange={() => {
                                  form.setFieldsValue({ expectedDeliveryTime: null });
                                }}
                              />
                            )}
                          </Form.Item>
                        </Col>
                        <Col span={7}>
                          <Form.Item colon={false} label="Expected Delivery Time">
                            {getFieldDecorator("expectedDeliveryTime", {
                              initialValue: recvData && recvData.expectedDeliveryDate
                                ? moment(recvData.expectedDeliveryDate)
                                : undefined,
                              rules: [
                                {
                                  required: true,
                                  message: "Select Expected Delivery Time!",
                                },
                                {
                                  validator: (rule, value, callback) => {
                                    const selectedDate = form.getFieldValue("expectedDeliveryDate");
                                    if (selectedDate && value) {
                                      const selectedDateTime = moment(selectedDate)
                                        .hour(value.hour())
                                        .minute(value.minute())
                                        .second(0)
                                        .millisecond(0);
                                      if (selectedDateTime.isBefore(moment().subtract(1, 'minute'))) {
                                        callback("Expected Delivery Time cannot be in the past!");
                                        return;
                                      }
                                    }
                                    callback();
                                  }
                                }
                              ],
                            })(
                              <TimePicker
                                style={{ width: "100%" }}
                                disabled={!editable || !form.getFieldValue("expectedDeliveryDate")}
                                disabledHours={getDisabledHours}
                                disabledMinutes={getDisabledMinutes}
                                format="HH:mm"
                                placeholder="HH:mm"
                                inputReadOnly={true}
                              />
                            )}
                          </Form.Item>
                        </Col>
                        <Col span={7}></Col>
                      </Row>
                    </Form>
                    <div className="Complaints">
                      <div style={{ display: "inline" }}>
                        <h3>Complaints</h3>
                        <span
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: "-2rem",
                            marginBottom: "1rem",
                          }}
                        >
                          {" "}
                          <Button
                            id="complaintAdd"
                            onClick={() => {
                              addComplaint();
                            }}
                          >
                            <PlusCircleOutlined />
                          </Button>
                        </span>
                      </div>
                      <div id="complaints">
                        <Table
                          columns={columns}
                          dataSource={complaintList}
                          disabled={!editable}
                        />
                      </div>
                    </div>
                    <WrappedUploadDocuments
                      editable={editable}
                      data={data}
                      fuelLevel={fuelLevel}
                      setFuelLevel={setFuelLevel}
                      PcheckedList={PcheckedList}
                      setPCheckedList={setPCheckedList}
                      setPIndeterminate={setPIndeterminate}
                      setPCheckAll={setPCheckAll}
                      fileList={fileList}
                      setFileList={setFileList}
                      RHSfileList={RHSfileList}
                      setRHSFileList={setRHSFileList}
                      RearfileList={RearfileList}
                      setRearFileList={setRearFileList}
                      LHSfileList={LHSfileList}
                      setLHSFileList={setLHSFileList}
                      TopfileList={TopfileList}
                      setTopFileList={setTopFileList}
                      additionalFileList={additionalFileList}
                      setAdditionalFileList={setAdditionalFileList}
                      FrontForm={FrontForm}
                      setFrontForm={setFrontForm}
                      RHSForm={RHSForm}
                      setRHSForm={setRHSForm}
                      LHSForm={LHSForm}
                      setLHSForm={setLHSForm}
                      RearForm={RearForm}
                      setRearForm={setRearForm}
                      TopForm={TopForm}
                      setTopForm={setTopForm}
                      frontImg={frontImg}
                      setFront={setFront}
                      RHSImg={RHSImg}
                      setRhs={setRhs}
                      LHSImg={LHSImg}
                      setLhs={setLhs}
                      RearImg={RearImg}
                      setRear={setRear}
                      TopImg={TopImg}
                      setTop={setTop}
                      setLoading={setLoading}
                      AccidentalDocuments={AccidentalDocuments}
                      setAccidentalDocuments={setAccidentalDocuments}
                      AdditionalImages={AdditionalImages}
                      setAdditionalImages={setAdditionalImages}
                      service={service}
                      batteryNo={batteryNo}
                      setBatteryNo={setBatteryNo}
                      batteryDoc={batteryDoc}
                      setBatteryDoc={setBatteryDoc}
                      batteryFileList={batteryFileList}
                      setBatteryFileList={setBatteryFileList}
                    />
                  </>
                </TabPane>
                <TabPane tab="Estimation" key="2">
                  <div
                    style={{
                      border: "1px solid lightgrey",
                      padding: "20px",
                      borderRadius: ".5rem",
                      marginRight: ".2rem",
                      marginTop: "1rem",
                      minHeight: "200px"
                    }}
                  >
                    <Spin spinning={estimationLoading}>
                      {estimationData && estimationData.length > 0 ? (
                        <Table
                          columns={estimationColumns}
                          dataSource={estimationData}
                          pagination={false}
                          size="middle"
                          bordered
                          scroll={estimationData.length > 10 ? { y: 450 } : undefined}
                          footer={() => {
                            const grandTotal = estimationData.reduce((acc, item) => acc + (parseFloat(item.amount) || 0), 0);
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  alignItems: "center",
                                  fontWeight: "bold",
                                  fontSize: "15px",
                                  padding: "4px 8px"
                                }}
                              >
                                <span>Grand Total : &nbsp;</span>
                                <span style={{ color: "#008080" }}>₹ {grandTotal.toFixed(2)}</span>
                              </div>
                            );
                          }}
                        />
                      ) : (
                        <div style={{ textAlign: "center", padding: "40px 0" }}>
                          <img src={empty} alt="No Data" style={{ width: "80px", marginBottom: "16px" }} />
                          <p style={{ color: "#8c8c8c", fontSize: "14px" }}>No Data Available</p>
                        </div>
                      )}
                    </Spin>
                  </div>
                </TabPane>
                <TabPane tab="Service History" key="3">
                  <div
                    style={{
                      border: "1px solid lightgrey",
                      padding: "40px 20px",
                      borderRadius: ".5rem",
                      marginRight: ".2rem",
                    }}
                  >
                    <ServiceHistory recvData={recvData} vehicleId={vid}  editable={false} />
                  </div>
                </TabPane>
                <TabPane tab="Documents" key="4">
                  <div
                    style={{
                      border: "1px solid lightgrey",
                      padding: "40px 20px",
                      borderRadius: ".5rem",
                      marginRight: ".2rem",
                    }}
                  >
                    <Documents
                      data={recvData.vehicle && recvData.vehicle.vehicle}
                      editable={false}
                      insurance={recvData.vehicle && recvData.vehicle.insurance}
                    />

                    <InsuranceForm
                      editable={false}
                      modifyData={recvData.vehicle && recvData.vehicle.insurance}
                    />
                  </div>
                </TabPane>
              </Tabs>
            </Col>
            <Col span={2}></Col>
          </Row>
        </>
      );
    };
const WrappedOverview = Form.create()(Overview);

export default WrappedOverview;